import type { ProjectTask } from '@/frontend/features/Fde/types'

export type TaskField =
  | 'title'
  | 'description'
  | 'status'
  | 'priority'
  | 'start_on'
  | 'due_on'
  | 'assignee_refs'
  | 'project_objective_id'
  | 'task_category_id'
  | 'parent_task_id'
export type ScalarTaskField = Exclude<TaskField, 'assignee_refs'>
export type ProjectTaskFormData = {
  title: string
  description: string
  status: string
  priority: string
  start_on: string
  due_on: string
  assignee_refs: string[]
  notify_agent_refs: string[]
  project_objective_id: string
  task_category_id: string
  parent_task_id: string
}

export function projectTaskFormValues(task: ProjectTask | null): ProjectTaskFormData {
  return {
    title: task?.title ?? '',
    project_objective_id: task?.project_objective_id ?? '',
    task_category_id: task?.task_category_id ?? '',
    parent_task_id: task?.parent_task_id ?? '',
    description: task?.description ?? '',
    status: task?.status ?? 'todo',
    priority: task?.priority ?? 'normal',
    start_on: task?.start_on ?? '',
    due_on: task?.due_on ?? '',
    assignee_refs: task?.assignees.map((assignee) => assignee.value) ?? [],
    notify_agent_refs: [],
  }
}

export function changedProjectTaskPayload(
  data: ProjectTaskFormData,
  fields: Set<TaskField>,
): Partial<ProjectTaskFormData> {
  const payload: Partial<ProjectTaskFormData> = {}
  fields.forEach((field) => {
    if (field === 'assignee_refs') {
      payload.assignee_refs = data.assignee_refs
      payload.notify_agent_refs = data.notify_agent_refs
    } else if (field === 'title') payload.title = data.title
    else if (field === 'description') payload.description = data.description
    else if (field === 'status') payload.status = data.status
    else if (field === 'priority') payload.priority = data.priority
    else if (field === 'start_on') payload.start_on = data.start_on
    else if (field === 'due_on') payload.due_on = data.due_on
    else if (field === 'project_objective_id')
      payload.project_objective_id = data.project_objective_id
    else if (field === 'task_category_id') payload.task_category_id = data.task_category_id
    else if (field === 'parent_task_id') payload.parent_task_id = data.parent_task_id
  })
  return payload
}
